/**
 * Lightweight slot value types + lookup helpers.
 *
 * Availability is now sourced from the backend (`useAvailableSlots`); the
 * frontend no longer GENERATES slots from booking config. These helpers just
 * model a slot ({start,end}) and build a fast membership lookup keyed by the
 * absolute start/end timestamps (so overnight slots key correctly across days).
 */

export interface GeneratedSlot {
  start: Date;
  end: Date;
}

export type GeneratedSlotLookup = Set<string>;

export const getGeneratedSlotKey = (start: Date, end: Date) =>
  `${start.getTime()}-${end.getTime()}`;

export const buildGeneratedSlotLookup = (slots: GeneratedSlot[]): GeneratedSlotLookup =>
  new Set(slots.map((slot) => getGeneratedSlotKey(slot.start, slot.end)));
